import axios from 'axios';

export interface PublicCompanyItem {
  id: number;
  companyName: string;
  businessType?: string;
  prefecture?: string;
  city?: string;
  logoUrl?: string;
  heroImageUrl?: string;
  businessContentPreview?: string;
  jobTypes?: string[];
  employeeCountRange?: string;
  isSponsor: boolean;
}

export interface PublicCompaniesResponse {
  success: true;
  data: {
    companies: PublicCompanyItem[];
    total: number;
  };
}

const apiClient = axios.create({
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export const publicCompanyService = {
  async getPublicCompanies(limit?: number): Promise<PublicCompaniesResponse> {
    const url =
      typeof limit === 'number' && Number.isFinite(limit) && limit > 0
        ? `/api/public/companies?limit=${limit}`
        : '/api/public/companies';
    const response = await apiClient.get<PublicCompaniesResponse>(url);
    return response.data;
  },
};
